import React from "react";
import Grid from "@material-ui/core/Grid";
import Skeleton from '@material-ui/lab/Skeleton';

export default function SkeletonCardTable(props) {
  return (
    <React.Fragment>
      <Grid item>
        <Skeleton animation="wave" variant="rect" width={312} height={480} style={{ borderRadius: 16 }} />
      </Grid>

      <Grid item>
        <Skeleton animation="wave" variant="rect" width={312} height={480} style={{ borderRadius: 16 }} />
      </Grid>

      <Grid item>
        <Skeleton animation="wave" variant="rect" width={312} height={480} style={{ borderRadius: 16 }} />
      </Grid>

      <Grid item>
        <Skeleton animation="wave" variant="rect" width={312} height={480} style={{ borderRadius: 16 }} />
      </Grid>

      <Grid item>
        <Skeleton animation="wave" variant="rect" width={312} height={480} style={{ borderRadius: 16 }} />
      </Grid>

      <Grid item>
        <Skeleton animation="wave" variant="rect" width={312} height={480} style={{ borderRadius: 16 }} />
      </Grid>

      <Grid item>
        <Skeleton animation="wave" variant="rect" width={312} height={480} style={{ borderRadius: 16 }} />
      </Grid>

      <Grid item>
        <Skeleton animation="wave" variant="rect" width={312} height={480} style={{ borderRadius: 16 }} />
      </Grid>
    </React.Fragment>
  )
}